var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM14.99 5C9.47 5 5 9.48 5 15C5 20.52 9.47 25 14.99 25C20.52 25 25 20.52 25 15C25 9.48 20.52 5 14.99 5ZM21.92 11H18.97C18.65 9.75 18.19 8.55 17.59 7.44C19.43 8.07 20.96 9.35 21.92 11ZM16.91 11C16.48 9.57 15.83 8.24 15 7.04C14.17 8.24 13.52 9.57 13.09 11H16.91ZM7.26 17C7.1 16.36 7 15.69 7 15C7 14.31 7.1 13.64 7.26 13H10.64C10.56 13.66 10.5 14.32 10.5 15C10.5 15.68 10.56 16.34 10.64 17H7.26ZM11.03 19H8.08C9.04 20.66 10.57 21.93 12.41 22.56C11.81 21.45 11.35 20.25 11.03 19ZM11.03 11H8.08C9.04 9.34 10.57 8.07 12.41 7.44C11.81 8.55 11.35 9.75 11.03 11ZM13.09 19C13.52 20.43 14.17 21.76 15 22.96C15.83 21.76 16.48 20.43 16.91 19H13.09ZM12.66 17C12.57 16.34 12.5 15.68 12.5 15C12.5 14.32 12.57 13.65 12.66 13H17.34C17.43 13.65 17.5 14.32 17.5 15C17.5 15.68 17.43 16.34 17.34 17H12.66ZM18.97 19C18.65 20.25 18.19 21.45 17.59 22.56C19.43 21.93 20.96 20.65 21.92 19H18.97ZM19.36 17C19.44 16.34 19.5 15.68 19.5 15C19.5 14.32 19.44 13.66 19.36 13H22.74C22.9 13.64 23 14.31 23 15C23 15.69 22.9 16.36 22.74 17H19.36Z",
    fill: "#4AFEBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.4a8a591cc881d00fe2eaded213f6cdb1.svg";
export { ForwardRef as ReactComponent };